import rp, { CodeEditorAdapter, CodeEditorOptions, CodeEditor, ContentOptions } from "@reporting/rp-app-host";
import { Resource } from "@reporting/rp-types/ext";
import { getFileExtensionInfo } from "../utils";

export class FileEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	private _file: Resource;

	constructor(readonly id: number) { super() }

	async getFile() {
		if (this._file) return this._file;
		this._file = this.id ? await rp.ms('extensions').get<Resource>(`resources/${this.id}`) : {};
		return this._file;
	}

	async getContent(opt: ContentOptions) : Promise<string> {
		return await rp.ms('extensions').get<string>(`resourceContent/${this.id}`, null, {
			parseResponse: false
		});
	}

	async save(content: string): Promise<boolean> {
		await rp.ms('extensions').post(`resourceContent/${this.id}`, content);
		return true;
	}

	async getOptions(): Promise<CodeEditorOptions> {
		const file = await this.getFile();
		return this.createOptions({
			history: false,
			language: file ? getFileExtensionInfo(file.name || 'unknown.txt').language : 'plain/text',
		});
	}

}
